enum VerificationStatusEnum {
	STARTED = 'STARTED',
	SUBMITTED = 'SUBMITTED',
	UPDATE_NEEDED = 'UPDATE_NEEDED',
	AUTO_COMPLETED = 'AUTO_COMPLETED',
	NEED_ATTENTION = 'NEED_ATTENTION',
	REJECTED = 'REJECTED',
	EXPIRED = 'EXPIRED',
	ONBOARDED = 'ONBOARDED'
}

export default VerificationStatusEnum;
